import React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { getPercentRewardTextToShow } from 'features/rewards/hooks/useRewards';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import RewardLogo from './RewardLogo';
export const RewardPreView = React.memo(({ onPress, reward, style, largerText, ...props }) => {
    const textSize = largerText
        ? { 'Text-16': true }
        : { 'Text-14': true };
    const styles = useStyles(styleSet);
    return (<TouchableBounce onPress={() => onPress?.(reward)} style={styles.touchable} hoverStyle={styles.hover} {...props}>
        <View style={[styles.cardView, style]}>
          <View style={[styles.centered, styles.itemContainer]}>
            <RewardLogo data={reward}/>
            <Text style={styles.text} {...textSize}>
              {getPercentRewardTextToShow(reward)}
            </Text>
          </View>
        </View>
      </TouchableBounce>);
});
RewardPreView.displayName = 'RewardPreView';
const styleSet = createStyleSheets((colors) => ({
    cardView: {
        margin: 0,
    },
    itemContainer: {
        borderRadius: rem(12),
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
    centered: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        paddingTop: rem(8),
    },
    hover: {
        backgroundColor: colors.control.hoverOnLight,
    },
    touchable: {
        marginRight: rem(8),
        borderRadius: rem(8),
    },
}));
